import axios from "axios";
import VueCookies from "vue-cookies"; // ✅ import trực tiếp

const auth = VueCookies.get('auth'); // ✅ dùng trực tiếp, không cần this

if (auth == '') location = 'http://localhost:8080/login';

const instance = axios.create({
    baseURL: 'https://api.udf.com.vn/user',
    headers: { Authorization: 'Bearer ' + auth }
});

instance.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response && error.response.status === 401) {
        // Xoá token (nếu cần)
        VueCookies.remove('auth');
        // Chuyển hướng về trang đăng nhập
        window.location.href = '/login';
    }

    return Promise.reject(error);
});

export default instance